import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=0833ca6b&"
import script from "./backButton.vue?vue&type=script&lang=js&"
export * from "./backButton.vue?vue&type=script&lang=js&"
import style0 from "./backButton.vue?vue&type=style&index=0&id=0833ca6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports